import { defineNuxtPlugin } from 'nuxt/app'
import ToastService from 'primevue/toastservice'
import type { ToastServiceMethods } from 'primevue/toastservice'
import DialogService from 'primevue/dialogservice'
import type { DialogServiceMethods } from 'primevue/dialogservice'
import ConfirmationService from 'primevue/confirmationservice'
import type { ConfirmationServiceMethods } from 'primevue/confirmationservice'

export default defineNuxtPlugin((nuxtApp) => {
  if (!nuxtApp.vueApp.config.globalProperties.$toast) {
    nuxtApp.vueApp.use(ToastService)
  }

  if (!nuxtApp.vueApp.config.globalProperties.$confirm) {
    nuxtApp.vueApp.use(ConfirmationService)
  }

  if (!nuxtApp.vueApp.config.globalProperties.$dialog) {
    nuxtApp.vueApp.use(DialogService)
  }

  const toast = nuxtApp.vueApp.config.globalProperties.$toast as ToastServiceMethods
  const dialog = nuxtApp.vueApp.config.globalProperties.$dialog as DialogServiceMethods
  const confirm = nuxtApp.vueApp.config.globalProperties.$confirm as ConfirmationServiceMethods

  return {
    provide: {
      toast,
      dialog,
      confirm,
    },
  }
})
